<template>
  <div>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <title>promocional y eventos</title>
      <path fill="#679940"
        d="M28.5,4H11.26l.45-.44a1,1,0,1,0-1.42-1.42L8,4.41A1,1,0,0,0,8,5.82l2.26,2.27a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.41L11,6H27.5V23a1,1,0,0,0,2,0V5A1,1,0,0,0,28.5,4Z"
      />
      <path fill="#679940"
        d="M18.5,20V16a3,3,0,0,0-3-3,3,3,0,0,0-2,.78,3,3,0,0,0-2-.78,3,3,0,0,0-3,3v4h2V16a1,1,0,0,1,2,0v4h2V16a1,1,0,0,1,2,0v4Z"
      />
      <path fill="#679940"
        d="M22.67,10.21A2.53,2.53,0,0,0,20.5,9h-1v2h1a.52.52,0,0,1,.46.26.53.53,0,0,1,0,.53l-1.38,2.76A1,1,0,0,0,20.5,16h3V14H22.12l.66-1.32A2.55,2.55,0,0,0,22.67,10.21Z"
      />
      <path fill="#679940"
        d="M21.71,23.91a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41L21,26H4.5V9a1,1,0,0,0-2,0V27a1,1,0,0,0,1,1H20.74l-.45.44a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L24,27.59a1,1,0,0,0,0-1.41Z"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: "Eventos"
};
</script>


// WEBPACK FOOTER //
// src/icons/EventosIcon.vue